import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    CMS_GRAPHQL_URI: z.string().url(),
    WOO_BASE_URL: z.string().url(),
    CONSUMER_KEY: z.string(),
    CONSUMER_SECRET: z.string(),
    STRIPE_SECRET_KEY: z.string(),
    REVALIDATION_SECRET_TOKEN: z.string(),
    APPLICATION_NEW_PASSWORD: z.string(),
    CMS_GRAPHQL_AUTH_USER: z.string(),
    PRE_BUILD_SITE: z
      .string()
      .refine((s) => s === "true" || s === "false")
      .transform((s) => s === "true"),
    SENDGRID_API_KEY: z.string(),
    CUSTOMER_LIST_SECRET: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_SITE_TITLE: z.string().min(8),
    NEXT_PUBLIC_SITE_SLUG: z.string().min(8),
    NEXT_PUBLIC_EMAIL: z.string().email(),
    NEXT_PUBLIC_EMAIL_TO: z.string().email(),
    NEXT_PUBLIC_BASE_URL: z.string().url(),
    NEXT_PUBLIC_SITE_TAG: z
      .string()
      .transform((s) => parseInt(s, 10))
      .pipe(z.number()),
    NEXT_PUBLIC_PLACE: z.string(),
    NEXT_PUBLIC_STRIPE_PUBLIC_KEY: z.string(),
    NEXT_PUBLIC_COUPON_ID: z
      .string()
      .transform((s) => parseInt(s, 10))
      .pipe(z.number()),
    NEXT_PUBLIC_PHONE: z.string().optional(),
    NEXT_PUBLIC_FACEBOOK_URL: z.string().url().optional(),
    NEXT_PUBLIC_INSTAGRAM_URL: z.string().url().optional(),
  },

  // If you're using Next.js < 13.4.4, you'll need to specify the runtimeEnv manually
  runtimeEnv: {
    CMS_GRAPHQL_URI: process.env.CMS_GRAPHQL_URI,
    WOO_BASE_URL: process.env.WOO_BASE_URL,
    CONSUMER_KEY: process.env.CONSUMER_KEY,
    CONSUMER_SECRET: process.env.CONSUMER_SECRET,
    NEXT_PUBLIC_SITE_TITLE: process.env.NEXT_PUBLIC_SITE_TITLE,
    NEXT_PUBLIC_SITE_SLUG: process.env.NEXT_PUBLIC_SITE_SLUG,
    NEXT_PUBLIC_EMAIL: process.env.NEXT_PUBLIC_EMAIL,
    NEXT_PUBLIC_EMAIL_TO: process.env.NEXT_PUBLIC_EMAIL_TO,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_SITE_TAG: process.env.NEXT_PUBLIC_SITE_TAG,
    NEXT_PUBLIC_PLACE: process.env.NEXT_PUBLIC_PLACE,
    STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,
    NEXT_PUBLIC_STRIPE_PUBLIC_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY,
    REVALIDATION_SECRET_TOKEN: process.env.REVALIDATION_SECRET_TOKEN,
    NEXT_PUBLIC_COUPON_ID: process.env.NEXT_PUBLIC_COUPON_ID,
    APPLICATION_NEW_PASSWORD: process.env.APPLICATION_NEW_PASSWORD,
    CMS_GRAPHQL_AUTH_USER: process.env.CMS_GRAPHQL_AUTH_USER,
    PRE_BUILD_SITE: process.env.PRE_BUILD_SITE,
    NEXT_PUBLIC_PHONE: process.env.NEXT_PUBLIC_PHONE,
    NEXT_PUBLIC_FACEBOOK_URL: process.env.NEXT_PUBLIC_FACEBOOK_URL,
    NEXT_PUBLIC_INSTAGRAM_URL: process.env.NEXT_PUBLIC_INSTAGRAM_URL,
    SENDGRID_API_KEY: process.env.SENDGRID_API_KEY,
    CUSTOMER_LIST_SECRET: process.env.CUSTOMER_LIST_SECRET,
  },
  // For Next.js >= 13.4.4, you only need to destructure client variables:
  // experimental__runtimeEnv: {
  //   NEXT_PUBLIC_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_PUBLISHABLE_KEY,
  // }
});
